const LOGOS = ["Helix", "Quanta", "Orbit", "Northbeam", "Polaris", "Meridian"];

export default function Logos() {
  return (
    <section className="logos">
      <div className="container">
        <p className="logos-label">Trusted by teams shipping at scale</p>
        <ul className="logos-grid">
          {LOGOS.map((name) => (
            <li key={name} className="logo-mark">
              {name}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
